var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "228px",
    height: "223px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#aa6532",
    d: "M 112.5,-0.5 C 112.833,-0.5 113.167,-0.5 113.5,-0.5C 115.863,4.18346 118.196,8.85013 120.5,13.5C 118.151,15.341 115.485,16.6743 112.5,17.5C 112.5,11.5 112.5,5.5 112.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#af7629",
    d: "M 111.5,-0.5 C 111.833,-0.5 112.167,-0.5 112.5,-0.5C 112.5,5.5 112.5,11.5 112.5,17.5C 112.5,20.5 112.5,23.5 112.5,26.5C 112.5,30.5 112.5,34.5 112.5,38.5C 105.772,35.4385 101.106,30.4385 98.5,23.5C 102.805,15.517 107.138,7.51696 111.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2783d",
    d: "M 120.5,13.5 C 122.588,15.3356 123.921,17.6689 124.5,20.5C 120.287,21.9399 116.287,23.9399 112.5,26.5C 112.5,23.5 112.5,20.5 112.5,17.5C 115.485,16.6743 118.151,15.341 120.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#a26925",
    d: "M 98.5,23.5 C 101.106,30.4385 105.772,35.4385 112.5,38.5C 112.5,39.8333 112.5,41.1667 112.5,42.5C 111.167,44.5 109.833,46.5 108.5,48.5C 101.619,45.284 95.9527,40.6174 91.5,34.5C 93.5974,30.6277 95.9308,26.961 98.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#f0b15a",
    d: "M 131.5,31.5 C 132.167,32.8333 132.833,34.1667 133.5,35.5C 123.278,36.5393 119.778,41.8726 123,51.5C 129.387,58.3781 136.22,59.0448 143.5,53.5C 145.008,55.1815 146.008,57.1815 146.5,59.5C 138.241,63.3452 129.907,63.3452 121.5,59.5C 118.896,54.6248 116.562,49.6248 114.5,44.5C 116.39,35.2811 122.057,30.9478 131.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#fec262",
    d: "M 133.5,35.5 C 136.833,41.5 140.167,47.5 143.5,53.5C 136.22,59.0448 129.387,58.3781 123,51.5C 119.778,41.8726 123.278,36.5393 133.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#de9b4f",
    d: "M 124.5,20.5 C 127.069,23.961 129.403,27.6277 131.5,31.5C 122.057,30.9478 116.39,35.2811 114.5,44.5C 113.833,43.8333 113.167,43.1667 112.5,42.5C 112.5,41.1667 112.5,39.8333 112.5,38.5C 112.5,34.5 112.5,30.5 112.5,26.5C 116.287,23.9399 120.287,21.9399 124.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#945d21",
    d: "M 91.5,34.5 C 95.9527,40.6174 101.619,45.284 108.5,48.5C 107.008,52.8178 105.008,56.8178 102.5,60.5C 102.719,59.325 102.386,58.325 101.5,57.5C 95.2753,54.5981 89.942,50.5981 85.5,45.5C 87.246,41.6733 89.246,38.0066 91.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6672e",
    d: "M 112.5,42.5 C 113.167,43.1667 113.833,43.8333 114.5,44.5C 116.562,49.6248 118.896,54.6248 121.5,59.5C 122.559,62.6179 123.892,65.6179 125.5,68.5C 126.833,71.1667 128.167,73.8333 129.5,76.5C 130.17,80.8773 132.67,82.8773 137,82.5C 144.109,81.8476 150.942,80.181 157.5,77.5C 157.5,78.1667 157.5,78.8333 157.5,79.5C 149.421,81.9706 141.421,84.6373 133.5,87.5C 126.387,89.5917 119.221,91.5917 112,93.5C 104.796,91.5983 97.6296,89.5983 90.5,87.5C 89.8333,87.5 89.5,87.1667 89.5,86.5C 93.8489,77.8022 98.1822,69.1356 102.5,60.5C 105.008,56.8178 107.008,52.8178 108.5,48.5C 109.833,46.5 111.167,44.5 112.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#864f1d",
    d: "M 85.5,45.5 C 89.942,50.5981 95.2753,54.5981 101.5,57.5C 102.386,58.325 102.719,59.325 102.5,60.5C 98.1822,69.1356 93.8489,77.8022 89.5,86.5C 81.7872,84.3217 74.1205,81.9884 66.5,79.5C 72.3299,67.8358 78.6632,56.5025 85.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dc984d",
    d: "M 121.5,59.5 C 129.907,63.3452 138.241,63.3452 146.5,59.5C 147.89,60.8993 148.89,62.5659 149.5,64.5C 146.755,67.0376 143.422,68.5376 139.5,69C 134.796,69.6477 130.129,69.481 125.5,68.5C 123.892,65.6179 122.559,62.6179 121.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c77f41",
    d: "M 149.5,64.5 C 151.083,66.6626 152.416,68.9959 153.5,71.5C 145.975,75.2055 137.975,76.8721 129.5,76.5C 128.167,73.8333 126.833,71.1667 125.5,68.5C 130.129,69.481 134.796,69.6477 139.5,69C 143.422,68.5376 146.755,67.0376 149.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b76c37",
    d: "M 153.5,71.5 C 154.82,73.4632 156.154,75.4632 157.5,77.5C 150.942,80.181 144.109,81.8476 137,82.5C 132.67,82.8773 130.17,80.8773 129.5,76.5C 137.975,76.8721 145.975,75.2055 153.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#4f2e11",
    d: "M 66.5,79.5 C 74.1205,81.9884 81.7872,84.3217 89.5,86.5C 89.5,87.1667 89.8333,87.5 90.5,87.5C 92.8171,91.1464 95.4838,94.4797 98.5,97.5C 99.8109,100.135 101.478,102.469 103.5,104.5C 106.129,108.463 109.129,112.129 112.5,115.5C 115.421,111.981 118.087,108.314 120.5,104.5C 122.547,102.45 124.214,100.117 125.5,97.5C 128.516,94.4797 131.183,91.1464 133.5,87.5C 141.421,84.6373 149.421,81.9706 157.5,79.5C 142.91,100.096 127.91,120.43 112.5,140.5C 96.9146,120.316 81.5813,99.9827 66.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0834d",
    d: "M 90.5,87.5 C 97.6296,89.5983 104.796,91.5983 112,93.5C 119.221,91.5917 126.387,89.5917 133.5,87.5C 131.183,91.1464 128.516,94.4797 125.5,97.5C 118.129,94.6401 110.462,93.8068 102.5,95C 100.68,95.2004 99.347,96.0337 98.5,97.5C 95.4838,94.4797 92.8171,91.1464 90.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cd9150",
    d: "M 125.5,97.5 C 124.214,100.117 122.547,102.45 120.5,104.5C 120.423,103.25 119.756,102.417 118.5,102C 116,101.5 113.5,101 111,100.5C 108.538,101.159 106.038,101.493 103.5,101.5C 103.5,102.5 103.5,103.5 103.5,104.5C 101.478,102.469 99.8109,100.135 98.5,97.5C 99.347,96.0337 100.68,95.2004 102.5,95C 110.462,93.8068 118.129,94.6401 125.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#633e1a",
    d: "M 57.5,100.5 C 58.0768,99.2267 58.7435,99.2267 59.5,100.5C 59.0302,101.463 58.3635,101.463 57.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2a754",
    d: "M 120.5,104.5 C 118.087,108.314 115.421,111.981 112.5,115.5C 109.129,112.129 106.129,108.463 103.5,104.5C 103.5,103.5 103.5,102.5 103.5,101.5C 106.038,101.493 108.538,101.159 111,100.5C 113.5,101 116,101.5 118.5,102C 119.756,102.417 120.423,103.25 120.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#7f5522",
    d: "M -0.5,129.5 C 0.833333,130.167 0.833333,130.167 -0.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.064
    },
    fill: "#623c1c",
    d: "M 82.5,133.5 C 83.0768,132.227 83.7435,132.227 84.5,133.5C 84.0302,134.463 83.3635,134.463 82.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#e4ab3a",
    d: "M 184.5,132.5 C 187.001,132.511 187.168,133.178 185,134.5C 184.536,133.906 184.369,133.239 184.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#673a16",
    d: "M 137.5,133.5 C 138.833,134.167 138.833,134.167 137.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#cd9430",
    d: "M 200.5,154.5 C 201.239,154.369 201.906,154.536 202.5,155C 201.534,156.678 200.201,157.345 198.5,157C 199.381,156.292 200.047,155.458 200.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.085
    },
    fill: "#8f6226",
    d: "M 125.5,155.5 C 126.525,155.897 126.692,156.563 126,157.5C 124.887,159.329 123.387,160.163 121.5,160C 122.357,157.981 123.691,156.481 125.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.097
    },
    fill: "#825822",
    d: "M 34.5,163.5 C 32.3702,161.873 30.3702,160.04 28.5,158C 31.5265,158.519 33.5265,160.352 34.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#79521e",
    d: "M 34.5,163.5 C 35.8333,164.167 35.8333,164.167 34.5,163.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.9031f93160ed7ad6c05864d527d280eb.svg";
export { ForwardRef as ReactComponent };